module.exports = __webpack_public_path__ + "img/Siper-Logo.54c5ef1b.png";